import { useCallback, useEffect, useState, type FormEvent } from 'react';
import { WorldFacts } from '@london-life/contracts';
import { Button } from '@london-life/ui/components/button';
import { Input } from '@london-life/ui/components/input';
import { Label } from '@london-life/ui/components/label';
import { PageHeader } from '@london-life/ui/admin/page-header';
import { ErrorNotice } from '@london-life/ui/feedback/error-notice';
import { api } from '../lib/api';
import { useRequest } from '../lib/use-request';

// super admin only: real-world facts the game shows. Check GOV.UK before changing the Prime Minister.
export function WorldPage() {
  const current = useRequest(useCallback(() => api.admin.worldFacts(), []));
  const [name, setName] = useState('');
  const [since, setSince] = useState('');
  const [saved, setSaved] = useState(false);
  useEffect(() => {
    if (!current.data) return;
    setName(current.data.world.primeMinister.name);
    setSince(current.data.world.primeMinister.since);
  }, [current.data]);
  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setSaved(false);
    const parsed = WorldFacts.safeParse({ primeMinister: { name, since } });
    if (!parsed.success) return current.fail(new Error(parsed.error.issues[0]?.message));
    try {
      await api.admin.saveWorldFacts(parsed.data);
      setSaved(true);
    } catch (problem) {
      current.fail(problem);
    }
  };
  return (
    <section>
      <PageHeader
        title="Real world"
        description="Real-world facts shown in the game. The game's own elections come later; until then the Prime Minister is the real one (check gov.uk/government/ministers/prime-minister)."
      />
      {current.error && <ErrorNotice error={current.error} onRetry={() => void current.reload()} />}
      {current.data && (
        <form className="admin-panel admin-form" onSubmit={(event) => void submit(event)}>
          <div className="admin-field">
            <Label htmlFor="pm-name">Prime Minister</Label>
            <Input id="pm-name" value={name} onChange={(event) => setName(event.target.value)} />
            <p className="admin-muted">Shown at the top of the game's homepage.</p>
          </div>
          <div className="admin-field">
            <Label htmlFor="pm-since">In office since</Label>
            <Input id="pm-since" type="date" value={since} onChange={(event) => setSince(event.target.value)} />
          </div>
          <div className="admin-page-actions">
            <Button type="submit">Save</Button>
            {saved && (
              <span role="status" className="admin-muted">
                Saved. Players see it within a minute.
              </span>
            )}
          </div>
        </form>
      )}
    </section>
  );
}
